module.exports = __webpack_public_path__ + "static/media/icon-supplies-smallcomb.448d2c62.svg";